namespace RedBullMOBILE360.SalesApp {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.SalesApp.WalletTransferGrid')
    export class WalletTransferGrid extends Serenity.EntityGrid<WalletTransferRow, any> {
        protected getColumnsKey() { return WalletTransferColumns.columnsKey; }
        protected getDialogType() { return WalletTransferDialog; }
        protected getIdProperty() { return WalletTransferRow.idProperty; }
        protected getInsertPermission() { return WalletTransferRow.insertPermission; }
        protected getLocalTextPrefix() { return WalletTransferRow.localTextPrefix; }
        protected getService() { return WalletTransferService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Import From Excel',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new WalletTransferImportDialog();
                    dialog.dialogOpen();
                }
            });

            return buttons;
        }

    }
}